export const camelToKebab = (str) => {
  let result = [];

  for (let i = 0; i < str.length; i++) {
    const x = str[i];

    if (x === x.toUpperCase()) {
      result.push('-' + x.toLowerCase());
    } else {
      result.push(x);
    }
  }

  return result.join('');
};

export const escapeRegExp = (string) =>
  string?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
